import { defineStore } from "pinia";

// store para la trazabilidad
export const useTrazabilidadStore = defineStore("trazabilidad", {
  state: () => ({
    fechaOfertaInicial: "",
    fechaFirmaInicial: "",
    fechaGanada: "",
  }),
});
